<!-- Main container with responsive layout -->
<div
	fxLayout.lt-md="column"
	fxLayout="row"
	fxLayout.xs="column"
	fxFlex="100%"
	fxLayoutAlign="start start"
>
	<!-- FIRST COLUMN -->
	<div
		fxLayout="column"
		fxFlex.lg="100%"
		fxLayoutAlign="start start"
		class="social-share"
	>
		<!-- Social share buttons -->
		<div
			fxLayout="row"
			fxFlex="100%"
			fxLayoutAlign="start start"
			fxFill
			ngClass.lt-sm="m-t-s"
		>
			<app-social-share-buttons
				[componentCalled]="this.type"
				[sharedLink]="this.shareLink"
				[disableSocialShare]="disablePayment"
				[fundraiserDetails]="this.data"
			></app-social-share-buttons>
		</div>

		<!-- Copy link to share section -->
		<div
			fxLayout="column"
			fxFlex.lg="100%"
			fxLayoutAlign="start start"
			class="social-share w-100"
			*ngIf="shareLink"
		>
			<h2 i18n="@@share_dialog_copy_link_to_share">Or Copy link to share</h2>
			<div
				fxLayout="row"
				fxFlex="100%"
				fxLayoutAlign="start baseline"
				fxLayoutAlign.lt-sm="start space-around"
				fxLayoutGap.lt-sm="5%"
				fxLayoutGap="0px"
				fxFill
			>
				<div
					fxLayoutAlign="space-between center"
					[ngClass]="{ 'p-xs': applyPadding }"
					class="grey-bg"
					fxFlex.gt-md="100%"
					fxFlex.lt-md="100%"
					fxFill
				>
					<!-- Display truncated share link -->
					<div fxLayout="column" fxFlex="80%" fxLayoutAlign="start start">
						<div id="shareLink">
							{{ truncateText(this.shareLink, 100) }}
						</div>
					</div>

					<!-- Copy link button -->
					<div
						fxLayout="column"
						fxLayout.lt-sm="row wrap"
						fxFlex="10%"
						fxLayoutAlign="start end"
						fXFlexAlign="start"
						*ngIf="!disablePayment"
					>
						<button
							class="copyLink"
							id="contentCopyButton"
							mat-icon-button
							matTooltip="{{ matTooltip }}"
							(click)="copyLink()"
							class="hover-class"
						>
							<mat-icon size="3x">content_copy</mat-icon>
						</button>
					</div>
				</div>
			</div>
			<h3 ngClass="p-t-xs" i18n="@@share_dialog_via_social_media">
				via any mail, instagram, facebook, whatsapp and many more.
			</h3>
		</div>
	</div>
	<!-- END FIRST COLUMN -->

	<!-- SECOND COLUMN -->
	<!-- [style.marginTop.px]="this.media.isActive('xs') ? '30' : '0'" -->
</div>
